import PopupPreview from '@components/popup-preview.vue'
import Vue from 'vue'

const PopupPreviewConstructor = Vue.extend(PopupPreview)

const popupPreview = () => {
  return new Promise((resolve, reject) => {
    const popupDom = new PopupPreviewConstructor({
      el: document.createElement('div'),
    })
    document.body.appendChild(popupDom.$el)
    var msg = {}
    msg.btn = {
      confirm: 'OK',
    }
    popupDom.confirm = (res) => {
      resolve(res)
      if (msg.confirm) {
        msg.confirm()
      }
      popupDom.showPopup = false
    }
  })
}
export default popupPreview
